/*
 * Copyright (c) 2023 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import { NameValueDataItem } from '../NameValueGroup';
import { ListTableColumnConfig } from '../ListTypes';
import { checkStringValueAndTranslate, formatStringUtcDateTime, DATA_UNAVAILABLE } from '../../../../utils/utils';
import { WithTranslation } from 'react-i18next';
import { AiClassificationHistoryItemDto } from '../../../../data/api/apiCommon.typings';

export enum ClassificationType {
    Cashbox,
    Store,
    Company,
}

export interface AiClassificationsHistoryTableData {
    insertedDate: string;
    startDate: string;
    endDate: string;
    classification: string;
    classificationProbability: string;
}

export const createAiClassificationsHistoryTableData = (
    data: AiClassificationHistoryItemDto[],
    t: WithTranslation['t'],
): NameValueDataItem[] => {
    return data.reduce((tableData, item) => {
        const dataItem: Partial<AiClassificationsHistoryTableData> = {};

        dataItem.insertedDate = formatStringUtcDateTime(item.insertedDateAtUtc, true);
        dataItem.startDate = formatStringUtcDateTime(item.startDateAtUtc, true, 'DD.MM.YYYY');
        dataItem.endDate = formatStringUtcDateTime(item.endDateAtUtc, true, 'DD.MM.YYYY');

        dataItem.classificationProbability =
            item.classificationProbability !== null && item.classificationProbability !== undefined
                ? `${item.classificationProbability}%`
                : DATA_UNAVAILABLE;
        dataItem.classification = checkStringValueAndTranslate(item.classification, 'domain.aiActivities.', t, true);

        tableData.push(dataItem);

        return tableData;
    }, []);
};

export const aiClassificationsHistoryConfig: ListTableColumnConfig<AiClassificationsHistoryTableData>[] = [
    {
        keyForValue: 'classification',
        translatePath: 'domain.aiActivity',
        isBold: true,
        align: 'left',
        isWithTooltip: true,
        maxWidth: 300,
    },
    {
        keyForValue: 'classificationProbability',
        translatePath: 'domain.aiProbability',
        align: 'left',
    },
    {
        keyForValue: 'startDate',
        translatePath: 'domain.startPeriod',
        align: 'left',
    },
    {
        keyForValue: 'endDate',
        translatePath: 'domain.endPeriod',
        align: 'left',
    },
    {
        keyForValue: 'insertedDate',
        translatePath: 'domain.aiClassificationDate',
        align: 'left',
    },
];

export const makePobabilityText = (min: number, max: number, t: WithTranslation['t']): string => {
    if (min !== max) return `${t('domain.aiProbability')}: (${min} - ${max})%`;
    return `${t('domain.aiProbability')}: ${min}%`;
};
